module.exports = __webpack_public_path__ + "808944c35f7a3fba5e789e500f3cc056.svg";